export default "__VITE_ASSET__C4kZUUHy__"